import {
  FilterMode,
  VatStatusCreateMutationVariables,
  VatStatus_OrderBy,
  VatStatus,
  SortOrder,
  VatStatus_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const vatStatusService = {
  createOne: buildCreateOne(
    (vatStatusCreateVariables: VatStatusCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.vatStatusCreate(vatStatusCreateVariables);
        return result.vatStatusCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.vatStatusOne({ id });
    return result.vatStatusOne as VatStatus;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: VatStatus_OrderBy[] | null = null,
    filter: VatStatus_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: VatStatus_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.vatStatusListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.vatStatusListWithOffset
    ) as VatStatus[];
    return { list, orderBy };
  },
};
